<template>
  <div class="content">
    <div class="options">
      <Checkbox
        v-model="localItem.outputPlainText"
        :disabled="!$hasPermission('prompts.write') || isBusy"
        label="Output Plain Text"
        @change="onChange"
      />
      <Checkbox
        v-model="localItem.normalizeParagraphs"
        :disabled="!$hasPermission('prompts.write') || isBusy"
        label="Normalize paragraphs"
        @change="onChange"
      />
    </div>
    <Code
      v-model="localItem.template"
      :read-only="!$hasPermission('prompts.write') || isBusy"
      :suggestions="localSuggestions"
      :language="'handlebars'"
      class="editor"
      :auto-height="true"
      @input="onChange"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Code from '@/components/common/Code';
import Checkbox from '@/components/common/Checkbox';

export default {
  components: {
    Code,
    Checkbox
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    suggestions: {
      type: Array,
      required: true
    },
    variables: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      localItem: {
        ...this.item,
        outputPlainText: this.item.outputPlainText || false,
        normalizeParagraphs: this.item.normalizeParagraphs === undefined ? true : this.item.normalizeParagraphs
      }
    };
  },
  computed: {
    ...mapState({
      documentation: s => s.prompts.sample?.documentation
    }),
    ...mapGetters({
      isBusy: 'prompts/isBusy'
    }),
    localSuggestions() {
      let docSuggestions = [];
      const documentation = this.documentation;
      if (documentation) {
        docSuggestions =
          documentation && Array.isArray(documentation.helperFunctions)
            ? documentation.helperFunctions.map(s => ({
                label: s.name,
                documentation: s.description,
                arguments: s.arguments,
                example: s.example
              }))
            : [];
      }

      return [...this.suggestions, ...docSuggestions];
    }
  },
  methods: {
    onChange() {
      this.$emit('change', { ...this.localItem });
    }
  }
};
</script>

<style scoped lang="scss">
.content {
  display: grid;
  gap: 5px;
  padding: 10px;

  .options {
    display: flex;
    justify-content: space-between;
    gap: 10px;
  }

  .editor {
    height: 200px;
  }
}
</style>
